const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const WEEK_MS = 7 * DAY_MS;
const MONTH_MS = 30 * DAY_MS;
const YEAR_MS = 365 * DAY_MS;

const plural = (n, unit) => `${n} ${unit}${n === 1 ? '' : 's'}`;

const overTwoYears = (compact) => (compact ? '>2y ago' : '>2 years ago');

export function formatRelativeTime(ts, { compact = false, now = Date.now() } = {}) {
    if (ts == null) return null;
    const d = new Date(Number(ts));
    if (Number.isNaN(d.getTime())) return null;
    const diff = now - d.getTime();

    if (diff >= 2 * YEAR_MS) return overTwoYears(compact);

    if (diff < MINUTE_MS) return compact ? 'now' : 'just now';

    if (diff < HOUR_MS) {
        const mins = Math.round(diff / MINUTE_MS);
        return compact ? `${mins}m ago` : `${plural(mins, 'minute')} ago`;
    }
    if (diff < DAY_MS) {
        const hours = Math.round(diff / HOUR_MS);
        return compact ? `${hours}h ago` : `${plural(hours, 'hour')} ago`;
    }
    if (diff < WEEK_MS) {
        const days = Math.round(diff / DAY_MS);
        return compact ? `${days}d ago` : `${plural(days, 'day')} ago`;
    }
    if (diff < MONTH_MS) {
        const weeks = Math.round(diff / WEEK_MS);
        return compact ? `${weeks}w ago` : `${plural(weeks, 'week')} ago`;
    }
    if (diff < YEAR_MS) {
        const months = Math.round(diff / MONTH_MS);
        return compact ? `${months}mo ago` : `${plural(months, 'month')} ago`;
    }
    const years = Math.round(diff / YEAR_MS);
    return compact ? `${years}y ago` : `${plural(years, 'year')} ago`;
}
